import { default as React } from "react";
import { withTranslation } from "react-i18next";
import {
  Card,
  CardBody,
  Col,
  Form,
  Row
} from "shards-react";
import { getTasksByOpportunityId } from '../../services/implementService';

class TasksHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          data:[],
        }
    }

    async componentDidMount() {
      const tasks = await getTasksByOpportunityId(this.props.currIdea.id);
      this.setState({data: tasks})
    }

    render() {
      const { data } = this.state
      if(!data || data.length === 0) {
        return null
      }

      return(
        <Row>
          <Col lg="12" className="m-auto">
            <h6 style={{fontWeight: 500, color: '#303030'}}>Tasks Completed:</h6>
            <Card small className="edit-user-details pt-4">
              <CardBody className="p-0">
                <Form className="my-auto" noValidate>
                {data.map((task, index) => {
                    const showSeparator = index !== data.length - 1
                    return(
                      <div>
                        <Row form className="pl-4">
                          <Col md="12" className="form-group my-auto">
                              <Row>
                                  <Col>
                                     {task.title}
                                  </Col>
                              </Row>
                          </Col>
                        </Row>
                        <Row className="mx-0">
                          <Col md="12" className="form-group">
                              {showSeparator && <div style={{height: 1, width: '100%', backgroundColor: 'black', opacity: 0.4, marginTop: 10}}></div>}
                          </Col>
                        </Row>
                      </div>
                    )
                  })
                }
                  </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>);
    }
}




export default withTranslation()(TasksHistory);